export * from '../dist/index.mjs';



//////////////////
// WEBPACK FOOTER
// ./~/@stripe/stripe-js/lib/index.mjs
// module id = 616
// module chunks = 0